//#region src/hooks/use-media-query/constants/default-breakpoints.ts
var e = {
	isMobile: !1,
	isTablet: !1,
	isDesktop: !1
};
//#endregion
export { e as defaultBreakpoints };
